import { render, staticRenderFns } from "./uploading.vue?vue&type=template&id=a2109a18&"
import script from "./uploading.vue?vue&type=script&lang=js&"
export * from "./uploading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports